import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { LP_UI_CONFIG } from '../core/tokens';
import { StorageService } from '../services/storage.service';
import {
  BannerNotification,
  MaintenanceMode,
  DismissBannerResponse,
} from '../models/banner-notification.model';

@Injectable({ providedIn: 'root' })
export class BannerNotificationApi {
  private readonly cfg = inject(LP_UI_CONFIG);
  private http = inject(HttpClient);
  private storage = inject(StorageService);

  private get headers() {
    return {
      Authorization: 'Bearer ' + this.storage.token(),
    };
  }

  async getMaintenanceMode(): Promise<MaintenanceMode[]> {
    try {
      return await firstValueFrom(
        this.http.get<MaintenanceMode[]>(`${this.cfg.host}api/maintenance/`, {
          headers: this.headers,
        })
      );
    } catch (error) {
      console.error('Failed to fetch maintenance mode:', error);
      return [];
    }
  }

  async getBannerNotifications(): Promise<BannerNotification[]> {
    try {
      return await firstValueFrom(
        this.http.get<BannerNotification[]>(`${this.cfg.host}api/banner_notifications/`, {
          headers: this.headers,
        })
      );
    } catch (error) {
      console.error('Failed to fetch banner notifications:', error);
      return [];
    }
  }

  async dismissBannerNotification(bannerType: string): Promise<DismissBannerResponse> {
    try {
      return await firstValueFrom(
        this.http.post<DismissBannerResponse>(
          `${this.cfg.host}api/dismiss_banner_notification/`,
          { BannerType: bannerType },
          { headers: this.headers }
        )
      );
    } catch (error) {
      console.error('Failed to dismiss banner notification:', error);
      return { success: false, message: 'Failed to dismiss notification' };
    }
  }
}
